<template>
  <div id="user-select-type-modal" :class="{disabled: loading}">
    <loader :loading="loading"></loader>
    <h3 class="font-lg wt-md align-center lh-tight">
      Welcome to A Perfect Space {{ $store.getters['user/account'].first_name }}.
    </h3>
    <h4 class="font-md align-center lh-light">
      We would love you to take the next step. What would you like to do?
    </h4>
    <section>
      <button type="button" class="button primary" @click="setType('hirer')">
        Hire a space
      </button>
      <button type="button" class="button secondary" @click="setType('lister')">
        List a space
      </button>
    </section>
  </div>
</template>

<script>
import BaseModal from '../Base'

export default {
  extends: BaseModal,
  data () {
    return {
      loading: false
    }
  },
  methods: {
    setType (type) {
      this.loading = true
      axios.put('/api/auth/type', { type })
          .then(response => {
            this.$store.commit('user/authenticated', response.data)

            this.$store.dispatch('account/commitMutation', {
              mutation: 'open',
              data: this.$store.getters['user/shouldCompleteProfile']
            })

            this.confirmAction()
          })
          .catch(() => {
            this.$toasted.show(
                'Oops, an error has occurred. Please refresh the page and try again.', {
                  type: 'error'
                })
          })
          .then(() => this.loading = false)
    }
  }
}
</script>
